// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-red {
  color: var(--elem-red-color);
}
.color-green {
  color: green;
}
.color-blue {
  color: var(--toolbtn-active-color);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.side {
  height: calc(var(--vh) * 100);
  display: flex;
  flex-direction: column;
  width: 350px;
  position: relative;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.side .section-header {
  background-color: initial;
  height: 50px;
  border-bottom: none;
}
.side-show-info-notification {
  height: calc(100% - 110px);
  overflow: inherit;
}
.side-list {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
div.text > span br {
  display: none;
}
.side-header {
  background: #F0F0F0;
}
.side-header .input-group {
  height: 40px;
}
.search-group {
  height: 40px;
}
.search-group .input-group-addon {
  height: inherit;
  width: initial;
  display: flex;
}
.search-group .input-group-addon i {
  margin: auto 0;
}
.search-group .input-group-addon.search-clear {
  display: flex;
  padding-right: 20px;
}
.search-group .input-group-addon.search-clear .svg-wrapper {
  width: 12px;
  height: 12px;
  margin: auto;
}
.search-group .input-group-addon.search-clear .svg-wrapper svg {
  height: inherit;
}
.side-body {
  flex: 1;
  overflow: auto;
  height: 100%;
}
.search {
  width: calc(100% - 40px);
  border: solid 1px #ccc;
  border-radius: 5px;
  height: 100%;
  padding-left: 10px;
  padding-right: 10px;
}
.search-clear {
  margin-left: 10px;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 5px;
  display: inline-block;
  background: #ccc;
  color: #ffffff;
  outline: none;
}
.search-clear:hover {
  background-color: #83c1ef;
}
.side-list-item {
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
}
.contact-list-item .fio {
  display: inline-block;
  margin-left: 5px;
  width: calc(100% - 15px);
}
.contact-list-item .status-icon {
  color: var(--message-grey-color);
}
.contact-list-item .status {
  margin-left: 15px;
  color: var(--message-grey-color);
}
.contacts-list {
  height: calc(var(--vh) * 100 - 100px);
  overflow-x: hidden;
}
.contacts-list .side-header .search {
  border: solid 1px #ccc;
  border-left: none;
  box-shadow: none;
}
.contacts-list .side-header .search:not(:last-child) {
  border-right: none;
}
.contacts-list .side-header .input-group-addon {
  background-color: white;
  cursor: pointer;
}
.side-list .list > li:last-child .side-list-item {
  margin-bottom: 0;
}
.side-list .list > li:last-child .hor-line {
  display: none;
}
.side-list-item {
  display: flex;
  width: 100%;
  height: 70px;
}
.side-list-item:hover {
  background-color: var(--list-item-bghover);
}
.side-list-item.focused {
  background-color: var(--list-item-activebgcolor) !important;
}
.side-list-item > *:not(:first-child) {
  margin: auto 0 auto 12px;
}
.side-list-item.chat-list-item + .hor-line {
  width: calc(100% - 68px);
  margin-left: 68px;
}
.side-list-item.contact-list-item + .hor-line {
  width: calc(100% - 94px);
  margin-left: 94px;
}
.side-list-item .fio-block > *,
.side-list-item .text-block > *,
.side-list-item .right-block > * {
  display: flex;
  height: 1.5em;
}
.side-list-item .fio-block > * > *,
.side-list-item .text-block > * > *,
.side-list-item .right-block > * > * {
  margin: auto 0;
}
.side-list-item.selected {
  background-color: var(--list-item-activebgcolor);
}
.side-list-item .name span,
.side-list-item .text span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.side-list-item .name span.last img.gap-left,
.side-list-item .text span.last img.gap-left {
  margin-left: 0.01em !important;
  width: 1.2em !important;
  height: 1.2em !important;
}
.side-list-item .name {
  font-size: var(--titleFontSize);
  filter: contrast(var(--fontContrast));
  max-height: var(--titleMaxHeight);
}
.side-list-item .text {
  font-size: var(--subTitleFontSize);
  filter: contrast(var(--fontContrast));
}
.chat-list-item .fio-block,
.chat-list-item .text-block,
.chat-list-item .fio-block-grow {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
}
.chat-list-item .time {
  text-align: right;
  font-size: .8em;
  color: var(--chat-time-color);
  margin: auto 0 auto 5px;
}
.chat-list-item .time span {
  margin-left: auto;
}
.chat-list-item .text {
  color: var(--chat-text-color);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.chat-list-item .text span.last a {
  color: var(--message-system-color);
}
.chat-list-item .text span.last a.botCommand {
  color: var(--chat-text-color);
}
.chat-list-item .item-icon {
  color: var(--chatlist-icon-color);
  margin-right: 5px;
}
.chat-list-item .icon-block {
  margin: auto 0;
}
.chat-list {
  height: calc(var(--vh) * 100 - 100px);
  overflow-x: hidden;
}
.call-list {
  height: calc(var(--vh) * 100 - 100px);
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/side/Side.vue"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,OAAO;EACP,cAAc;EACd,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;;;EAGE,aAAa;EACb,aAAa;AACf;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,gDAAgD;AAClD;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;AACA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB","sourcesContent":[".color-red {\n  color: var(--elem-red-color);\n}\n.color-green {\n  color: green;\n}\n.color-blue {\n  color: var(--toolbtn-active-color);\n}\n.fade-enter-active,\n.fade-leave-active {\n  transition: opacity .5s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n.side {\n  height: calc(var(--vh) * 100);\n  display: flex;\n  flex-direction: column;\n  width: 350px;\n  position: relative;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.side .section-header {\n  background-color: initial;\n  height: 50px;\n  border-bottom: none;\n}\n.side-show-info-notification {\n  height: calc(100% - 110px);\n  overflow: inherit;\n}\n.side-list {\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: 100%;\n}\ndiv.text > span br {\n  display: none;\n}\n.side-header {\n  background: #F0F0F0;\n}\n.side-header .input-group {\n  height: 40px;\n}\n.search-group {\n  height: 40px;\n}\n.search-group .input-group-addon {\n  height: inherit;\n  width: initial;\n  display: flex;\n}\n.search-group .input-group-addon i {\n  margin: auto 0;\n}\n.search-group .input-group-addon.search-clear {\n  display: flex;\n  padding-right: 20px;\n}\n.search-group .input-group-addon.search-clear .svg-wrapper {\n  width: 12px;\n  height: 12px;\n  margin: auto;\n}\n.search-group .input-group-addon.search-clear .svg-wrapper svg {\n  height: inherit;\n}\n.side-body {\n  flex: 1;\n  overflow: auto;\n  height: 100%;\n}\n.search {\n  width: calc(100% - 40px);\n  border: solid 1px #ccc;\n  border-radius: 5px;\n  height: 100%;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.search-clear {\n  margin-left: 10px;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 5px;\n  display: inline-block;\n  background: #ccc;\n  color: #ffffff;\n  outline: none;\n}\n.search-clear:hover {\n  background-color: #83c1ef;\n}\n.side-list-item {\n  cursor: pointer;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.contact-list-item .fio {\n  display: inline-block;\n  margin-left: 5px;\n  width: calc(100% - 15px);\n}\n.contact-list-item .status-icon {\n  color: var(--message-grey-color);\n}\n.contact-list-item .status {\n  margin-left: 15px;\n  color: var(--message-grey-color);\n}\n.contacts-list {\n  height: calc(var(--vh) * 100 - 100px);\n  overflow-x: hidden;\n}\n.contacts-list .side-header .search {\n  border: solid 1px #ccc;\n  border-left: none;\n  box-shadow: none;\n}\n.contacts-list .side-header .search:not(:last-child) {\n  border-right: none;\n}\n.contacts-list .side-header .input-group-addon {\n  background-color: white;\n  cursor: pointer;\n}\n.side-list .list > li:last-child .side-list-item {\n  margin-bottom: 0;\n}\n.side-list .list > li:last-child .hor-line {\n  display: none;\n}\n.side-list-item {\n  display: flex;\n  width: 100%;\n  height: 70px;\n}\n.side-list-item:hover {\n  background-color: var(--list-item-bghover);\n}\n.side-list-item.focused {\n  background-color: var(--list-item-activebgcolor) !important;\n}\n.side-list-item > *:not(:first-child) {\n  margin: auto 0 auto 12px;\n}\n.side-list-item.chat-list-item + .hor-line {\n  width: calc(100% - 68px);\n  margin-left: 68px;\n}\n.side-list-item.contact-list-item + .hor-line {\n  width: calc(100% - 94px);\n  margin-left: 94px;\n}\n.side-list-item .fio-block > *,\n.side-list-item .text-block > *,\n.side-list-item .right-block > * {\n  display: flex;\n  height: 1.5em;\n}\n.side-list-item .fio-block > * > *,\n.side-list-item .text-block > * > *,\n.side-list-item .right-block > * > * {\n  margin: auto 0;\n}\n.side-list-item.selected {\n  background-color: var(--list-item-activebgcolor);\n}\n.side-list-item .name span,\n.side-list-item .text span {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.side-list-item .name span.last img.gap-left,\n.side-list-item .text span.last img.gap-left {\n  margin-left: 0.01em !important;\n  width: 1.2em !important;\n  height: 1.2em !important;\n}\n.side-list-item .name {\n  font-size: var(--titleFontSize);\n  filter: contrast(var(--fontContrast));\n  max-height: var(--titleMaxHeight);\n}\n.side-list-item .text {\n  font-size: var(--subTitleFontSize);\n  filter: contrast(var(--fontContrast));\n}\n.chat-list-item .fio-block,\n.chat-list-item .text-block,\n.chat-list-item .fio-block-grow {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1;\n  overflow: hidden;\n}\n.chat-list-item .time {\n  text-align: right;\n  font-size: .8em;\n  color: var(--chat-time-color);\n  margin: auto 0 auto 5px;\n}\n.chat-list-item .time span {\n  margin-left: auto;\n}\n.chat-list-item .text {\n  color: var(--chat-text-color);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.chat-list-item .text span.last a {\n  color: var(--message-system-color);\n}\n.chat-list-item .text span.last a.botCommand {\n  color: var(--chat-text-color);\n}\n.chat-list-item .item-icon {\n  color: var(--chatlist-icon-color);\n  margin-right: 5px;\n}\n.chat-list-item .icon-block {\n  margin: auto 0;\n}\n.chat-list {\n  height: calc(var(--vh) * 100 - 100px);\n  overflow-x: hidden;\n}\n.call-list {\n  height: calc(var(--vh) * 100 - 100px);\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
